<template>
    <div class="about">
        <sw-parallax
                style="background-image: url('/static/media/service_hero.jpg');
                height: 300px; background-position-y: -150px;">
        </sw-parallax>
        <div class="container">
            <div class="row">
                <div class="column">
                    <article>
                        <h2>Ontmoet ons</h2>
                        <p>
                            Onze jonge organisatie bestaat uit een vaste kern van onderstaande toppers. Daarnaast hebben
                            we nog wisselende ondersteuning van 7 tot 10 indirecte collega’s om onze diensten elke dag
                            een beetje beter te maken.
                        </p>
                    </article>
                </div>
            </div>

            <div class="row" style="margin-bottom: 60px;">
                <div class="three columns">
                    <div class="flip-container" ontouchstart="this.classList.toggle('hover');">
                        <div class="flipper">
                            <div class="front">
                                <figure class="employee">
                                    <img src="../assets/herman.jpg" width="300" height="450" alt="Herman Brandsma">
                                </figure>
                            </div>
                            <div class="back">
                                <div class="name_box">
                                    <div class="content">
                                        Herman Brandsma <br/>
                                        <span class="lighter">CEO</span> <br/>
                                        <a href="https://www.linkedin.com/in/hermanbrandsma/?locale=nl_NL">
                                            <font-awesome-icon :icon="['fab', 'linkedin']" fixed-width/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="three columns">
                    <div class="flip-container" ontouchstart="this.classList.toggle('hover');">
                        <div class="flipper">
                            <div class="front">
                                <figure class="employee">
                                    <img src="../assets/hendrik.jpg" width="300" height="450" alt="Hendrik Grunstra">
                                </figure>
                            </div>
                            <div class="back">
                                <div class="name_box">
                                    <div class="content">
                                        Hendrik Grunstra <br/>
                                        <span class="lighter">CTO</span> <br/>
                                        <a href="https://www.linkedin.com/in/hendrikgrunstra/?locale=nl_NL">
                                            <font-awesome-icon :icon="['fab', 'linkedin']" fixed-width/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="three columns">
                    <div class="flip-container" ontouchstart="this.classList.toggle('hover');">
                        <div class="flipper">
                            <div class="front">
                                <figure class="employee">
                                    <img src="../assets/arjen.jpg" width="300" height="450" alt="Arjen Postma">
                                </figure>
                            </div>
                            <div class="back">
                                <div class="name_box">
                                    <div class="content">
                                        Arjen Postma <br/>
                                        <span class="lighter">Software Developer</span> <br/>
                                        <a href="https://www.linkedin.com/in/a-postma/?locale=nl_NL">
                                            <font-awesome-icon :icon="['fab', 'linkedin']" fixed-width/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="three columns">
                    <div class="flip-container" ontouchstart="this.classList.toggle('hover');">
                        <div class="flipper">
                            <div class="front">
                                <figure class="employee">
                                    <img src="../assets/maarten.jpg" width="300" height="450" alt="Maarten Grassmid">
                                </figure>
                            </div>
                            <div class="back">
                                <div class="name_box">
                                    <div class="content">
                                        Maarten Grassmid <br/>
                                        <span class="lighter">Software Developer</span> <br/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" style="margin-bottom: 120px;">
                <div class="three columns">
                    <div class="flip-container" ontouchstart="this.classList.toggle('hover');">
                        <div class="flipper">
                            <div class="front">
                                <figure class="employee">
                                    <img src="../assets/svenmark.jpg" width="300" height="450" alt="Sven Mark Hofstra">
                                </figure>
                            </div>
                            <div class="back">
                                <div class="name_box">
                                    <div class="content">
                                        Sven Mark Hofstra <br/>
                                        <span class="lighter">Software Developer</span> <br/>
                                        <a href="https://www.linkedin.com/in/sven-mark-hofstra/?locale=nl_NL">
                                            <font-awesome-icon :icon="['fab', 'linkedin']" fixed-width/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sw-parallax
                style="background-image: url('/static/media/Overview-kantoor-642A1494-uitgesneden.jpg');
                height: 300px; background-position-y: top;">
        </sw-parallax>
        <div class="container" style="margin-bottom: 60px;">
            <div class="row">
                <div class="column">
                    <article>
                        <h2>Versterk ons</h2>
                        <p>
                            Werken binnen het leukste team van Friesland? We’ve got you covered! Op een informele en
                            professionele manier kun jij jezelf bij ons ontwikkelen. Hieronder vind je de vacatures die
                            we momenteel open hebben staan. Wil je ons op technologisch gebied versterken? Stuur ons dan
                            een berichtje of doe een open sollicitatie.
                        </p>
                    </article>
                </div>
            </div>
            <div class="row">
                <div class="column">
                    <!--<router-link to="/vacancies/communicatief_talent" class="vacancy">-->
                    <!--Communicatief talent-->
                    <!--</router-link>-->
                    <!--<router-link to="/vacancies/stage_software_development" class="vacancy">-->
                    <!--(Afstudeer)stage software development-->
                    <!--</router-link>-->
                    <!--<router-link to="/vacancies/programma_manager" class="vacancy">-->
                    <!--Programma manager-->
                    <!--</router-link>-->
                    <router-link to="/vacancies/open" class="vacancy">
                        Open sollicitatie
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SwParallax from "@/components/Parallax.vue";

    export default {
        metaInfo: {
            title: "Over ons",
            meta: [
                {
                    'property': 'og:url',
                    'content': url + 'about',
                    'vmid': 'og:url'
                },
                {
                    'property': 'og:title',
                    'content': 'Over ons - SwBase Systems BV - Swbase.com',
                    'vmid': 'og:title'
                },
            ]
        },
        components: {
            SwParallax
        }
    };
</script>

<style scoped="scoped">
    .employee {
        margin: 0;
        padding: 0;
        max-width: 100%;
        height: 300px;
        line-height: 300px;
        text-align: center;
    }

    .employee img {
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
    }

    /* entire container, keeps perspective */
    .flip-container {
        perspective: 1000px;
    }

    /* flip the pane when hovered */
    .flip-container:hover .flipper, .flip-container.hover .flipper {
        transform: rotateY(180deg);
    }

    .flip-container, .front, .back {
        width: 100%;
        height: 300px;
    }

    .flipper {
        transition: 0.4s;
        transform-style: preserve-3d;

        position: relative;
    }

    .front, .back {
        backface-visibility: hidden;

        position: absolute;
        top: 0;
        left: 0;
    }

    .front {
        z-index: 2;
        /* for firefox 31 */
        transform: rotateY(0deg);
    }

    .back {
        transform: rotateY(180deg);
    }

    .name_box {
        position: relative;
        background-color: #0FA0CE;
        color: white;
        text-align: center;
        width: 100%;
        height: 100%;
    }

    .name_box a:hover {
        color: white;
    }

    .name_box .content {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 50px;
    }

    .vacancy {
        display: block;
        line-height: 30px;
        margin-bottom: 15px;
        font-size: 22px;
        cursor: pointer;
        border: 1px solid #DDD;
        padding: 4px 16px;
        border-radius: 5px;
        text-decoration: none;
    }

    .vacancy:hover {
        background-color: #FCFCFC;
    }

    @media (max-width: 750px) {
        .employee img,
        .name_box {
            max-width: 200px;
        }

        .name_box {
            margin: 0 auto;
        }

        .flip-container {
            margin-bottom: 15px;
        }
    }
</style>